import React from "react";
import "./movielist.css";
import Cards from "../Card/card";

const MovieList = ({ movies, category }) => {
  return (
    <div className="movie__list">
      {movies && (
        <h2 className="list__title text-left font-bold text-white">
          {`${category} movies`.toUpperCase()}
        </h2>
      )}
      <div className="list__cards">
        {movies?.map((movie) => (
          <Cards movie={movie} key={movie?.id} />
        ))}
      </div>
    </div>
  );
};

export default MovieList;
